import React from "react";
import { useHistory } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { PageSettings } from "./../config/page-settings.js";
import { useAuth } from "../components/content/auth.jsx";

class SelectLevel extends React.Component {
	static contextType = PageSettings;

	constructor(props) {
		super(props);

		this.state = {
      activeBg: '../assets/FarmField-N1906P37006H.jpg',
      options_nivel: JSON.parse(localStorage.grupos), 
      nivel: "",
      nivel_name:"",
		}
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleNivel = this.handleNivel.bind(this);
	}

	componentDidMount() {
		this.context.handleSetPageSidebar(false);
		this.context.handleSetPageHeader(false);
	}

  handleNivel(e) {
    if(e.target.value!==""){
      this.setState({ nivel: e.target.value});
  
      this.state.options_nivel.map((option) => {
        if(option.id === e.target.value){
          this.setState({nivel_name: option.description});
        } 
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.state.nivel!==""){
      localStorage.nivel_actual = this.state.nivel;
      localStorage.nivel_name = this.state.nivel_name;
      window.location.href="/";
    }
  }
  
	render() {
		return (
			<React.Fragment>
				<div className="login-cover">
					<div className="login-cover-image" style={{ backgroundImage: 'url(' + this.state.activeBg + ')'}}></div>
					<div className="login-cover-bg"></div>
				</div>
       
				<div className="login login-v2">
        <Panel shaded >
              <PanelBody>
					<div className="login-header " >
          
						<div className="brand m-t-20" >
							<img className="logo" style={{width:"12%",height:"12%"}} src="../favicon.ico" alt="icon"></img><b>SINAIP</b> 
						</div>
					</div>
					<div className="login-content">
						<form className="margin-bottom-0" onSubmit={this.handleSubmit}>
							<div className="form-group m-b-20">
                <select
                        onChange={this.handleNivel}
                        name="tipo_regente_id"
                        className="form-control form-control-lg"
                        required
                        style={{border:'1px solid gray'}}
                      >
                        <option className="dropdown-item">Seleccione un nivel...</option>
                        {this.state.options_nivel.map((option) => (
                          <option className="dropdown-item" key={option.id} value={option.id} name={option.description}>
                            {option.description}
                          </option>
                        ))}
                      </select>
							</div>
							
							<div className="login-buttons">
								<button type="submit" className="btn btn-primary btn-block btn-lg">Entrar</button>
							</div>
							
						</form>
           
					</div>
          </PanelBody>
          </Panel>
				</div>
       
			
			</React.Fragment>
		)
	}
}
//export default SelectLevel;

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <SelectLevel auth={auth} history={history} {...props} />;
};
